const prefix = '/users' as const;

export const UserDetails: Record<string, string> = {
  getUserDetails: `${prefix}/me`,
  downloadPersonalDetails: `${prefix}/me/exports`,
};
